import { DirectiveBinding } from 'vue';
import { PermissionService } from '@/services/PermissionService';

export default {
  inserted(el: HTMLElement, binding: DirectiveBinding<any>, vnode: any) {
    const permissionService = vnode.context.$permissionService;

    if (!permissionService) {
      console.warn('Permission service not initialized');
      return;
    }

    const { value } = binding;
    if (!permissionService.hasPermission(value)) {
      el.parentNode?.removeChild(el);
    }
  },

  update(el: HTMLElement, binding: DirectiveBinding<any>, vnode: any) {
    const permissionService = vnode.context.$permissionService;

    if (!permissionService) {
      console.warn('Permission service not initialized');
      return;
    }

    const { value } = binding;
    if (!permissionService.hasPermission(value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  },
};
